import { NgModule } from '@angular/core';
import { AccordionModule } from 'components/accordion/accordion.module';
import { WorkItemLaneListModule } from 'components/work-item-lane-list/work-item-lane-list.module';
import { WorkLayoutComponent } from 'components/work-layout/work-layout.component';

@NgModule({
  imports: [
    AccordionModule,
    WorkItemLaneListModule
  ],
  declarations: [
    WorkLayoutComponent
  ],
  exports: [
    WorkLayoutComponent
  ]
})
export class WorkLayoutModule {}
